import React, { useEffect, useState, useMemo } from "react";
import styled from "styled-components";
import {
  ButtonFilled,
  ButtonOutlined,
  Buttontransparent,
} from "../../../Reusablecomponents/UIButtons";
import UIModal from "../../../Reusablecomponents/UIModal";
import { CloseOutlined, EyeOutlined, LeftOutlined } from "@ant-design/icons";
import {
  Tooltip,
  Col,
  Form,
  InputNumber,
  message,
  Modal,
  Row,
  Select,
  Spin,
  Tabs,
  Upload,
} from "antd";
import { ReactComponent as DeleteIcon } from "../../../assets/images/delete-icon.svg";
import { ReactComponent as EditIcon } from "../../../assets/images/Editicon.svg";
import { StyledTable } from "../../../Reusablecomponents/UITable/UITable";
import { ReactComponent as DownloadIcon } from "../../../assets/images/download1.svg";
import GridBuilder from "../../../UIBuilderEngine/GridBuilder";
import ReusableDrawer from "../../../Reusablecomponents/ReusableDrawer";
import { CALL_API } from "../../../Common/api";
import { useSelector } from "react-redux";
import moment from "moment";
import FilesTable from "../../../Reusablecomponents/FilesTable";

const WrapperBox = styled.div`
  .consingment_container {
    display: flex;
    width: 100%;
    justify-content: space-between;
  }
  @media (min-width: 320px) and (max-width: 420px) {
    .consingment_container {
      display: flex;
      flex-direction: column;
    }
    .consingment_container_two {
      display: flex;
      gap: 10px;
    }
    .consingment_container_formbresponsive {
      display: flex;
      flex-direction: row;
      gap: 20px;
      justify-content: end;
    }

    .container_for_consignorpage {
      .consignor_code {
        width: 100% !important;
      }
    }
  }
  @media (min-width: 421px) and (max-width: 768px) {
    .container_for_consignorpage {
      .consignor_code {
        width: 50% !important;
      }
    }
  }
  @media (min-width: 769px) and (max-width: 991px) {
    .container_for_consignorpage {
      .consignor_code {
        width: 33% !important;
      }
    }
  }

  @media (max-width: 320px) {
    .tabsectionfor_table {
      display: flex;
      flex-direction: column;
    }
  }

  .consingment_container_two {
    display: flex;
    align-items: center;
  }
  .consingment_container_record {
    display: flex;
    flex-direction: column;
    gap: 19px;
    text-align: justify;
  }
  p {
    margin-bottom: 0px;
    font-size: 16px;
    font-weight: 400;
  }
  .Create_btn {
    border: none;
    outline: none;
    background-color: rgb(235, 247, 237);
    color: white;
    border-radius: 50%;
    padding: 17px 13px 17px 13px;
    font-size: 16px;
  }

  .left_outlined_icon {
    color: rgb(44, 150, 61);
    transform: scale(0.8);
  }
  .Create_btn_edit {
    border-radius: 50%;
    padding: 9px;
    border: 1px solid rgb(231, 231, 237);
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: rgb(235, 247, 237);
  }
  .container_for_consignorpage {
    background-color: rgb(248, 248, 248);
    border-radius: 12px;
    margin: 16px 5px 20px 5px;
  }
  .container_for_consignorpage {
    display: flex;
    width: 100%;
    padding: 10px 10px 10px 10px;
    flex-wrap: wrap;
  }
  .consignor_code {
    width: 25%;
    padding: 10px 10px 10px 10px;
    margin: 5px 0px 5px 0px;
  }
  .consignor_code_container {
    width: 100%;
    padding: 10px 10px 10px 10px;
    margin: 5px 0px 5px 0px;
  }
  .consignor_code > label {
    color: rgb(152, 161, 181);
    padding: 5px 0px 5px 0px;
    font-size: 14px;
  }
  .Add_btn {
    border: none;
  }
  .tabsectionfor_table {
    display: flex;
    justify-content: space-between;
  }
  .ant-tabs-tab {
    font-size: 15px !important;
    font-weight: 400 !important;
    color: #5f6d8c !important;
    border-radius: 27px !important;
  }
  .ant-tabs-tab-active .ant-tabs-tab-btn {
    color: #2c963d !important;
  }
  .ant-tabs-tab:hover {
    color: #5f6d8c !important; /* Darker green on hover */
  }
  .ant-table-tbody > tr > td {
    padding: 18px 0px 18px 0px !important;
  }
  .consignor_tab_container.ant-tabs-top > .ant-tabs-nav::before {
    border-bottom: unset !important;
  }
  .ant-tabs > .ant-tabs-nav .ant-tabs-nav-list {
    display: flex;
    gap: 15px;
  }
  .Creating_Consignor {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 7px 7px 7px 5px;
    margin-bottom: 19px;
    border-bottom: 1px solid rgb(231 231, 237);
  }
`;

const Consignordetails = ({
  setDrawyeropen,
  setFormData,
  consignee,
  setIsView,
  setIsEdit,
  handleDelete,
  dloading,
  isDeleteAllowed,
  isUpdateAllowed
}) => {
  const [form] = Form.useForm();
  const { Option } = Select;
  const vehicleType = useSelector((state) => state?.authTracking?.vehicleType);
  const kpiNameList = useSelector((state) => state?.authTracking?.kpiNameList);
  const userInfo = useSelector((state) => state?.authTracking?.userInfo);
  const [isModalOpeN, setIsModalOpeN] = useState(false);
  const [loading, setLoading] = useState(false);
  const [kpiList, setKpiList] = useState(false);
  const [activekey, setactivekey] = useState("1");
  const [isKpiEdit, setIsKpiEdit] = useState(false);
  const [kpiDetailsData, setKpiDetailsData] = useState({});
  const [filesList, setFilesList] = useState([]);
  const [isDeleteModalVisible, setIsDeleteModalVisible] = useState(false);
  const [deleteId, setDeleteId] = useState(null); // To store the ID of the consignment to delete
  const [CustomData, setCustomData] = useState([]);
  const reduxPermissions = useSelector(
    (state) => state?.authTracking?.myPermissionList || {},
  );
  const hasPermission = (seccode, action) => {
    if (!seccode || !action) return false;
    const code = seccode.toUpperCase();
    const act = action.toUpperCase();
    return (
      Array.isArray(reduxPermissions?.[code]) &&
      reduxPermissions[code].includes(act)
    );
  };

  //customedata api
  const getcustomedatabyRefId = async () => {
    try {
      // const { data } = await CALL_API(
      //   "GET",
      //   `mastertable/GetCustomeData?RefId=${fuelId}`
      // );
      const { data } = await CALL_API("POST", `mastertable/GetByReftab`, {
        ReftableId: "Entity",
        RefId: consignee?.ENTID,
        Active: 1,
        McId: userInfo?.MCID,
      });

      if (Array.isArray(data)) {
        setCustomData(data);
      } else if (typeof data === "object" && data !== null) {
        // Wrap the single object in an array
        setCustomData([data]);
      } else {
        setCustomData([]);
        console.warn("Unexpected custom data format:", data);
      }
    } catch (error) {
      console.error("Error fetching custom data:", error);
      setCustomData([]);
    }
  };
  const fetchKPIData = async () => {
    setLoading(true);
    const { data } = await CALL_API("GET", `entity/get_all_entity_kpi`, {});
    setKpiList(data?.data);
    setLoading(false);
  };

  const getFileData = async () => {
    setLoading(true);
    const { data } = await CALL_API("POST", `trip/getFileTab`, {
      refTab: "ENTITY",
      refId: consignee?.ENTID,
    });
    setFilesList(data);
    setLoading(false);
  };

  const handleFileUpload = async (payload) => {
    setLoading(true);
    const { data } = await CALL_API("POST", "common/file/addFile", payload);
    setLoading(false);
    getFileData();
  };

  useEffect(() => {
    getFileData();
    fetchKPIData();
    getcustomedatabyRefId();
  }, [consignee]);

  const data1 = [
    {
      key: "1",
      name: "Location Image",
      filesize: "53 KB",
      filetype: "PDF",
    },
    {
      key: "2",
      name: "Location Image",
      filesize: "53 KB",
      filetype: "PDF",
    },
    {
      key: "3",
      name: "Location Image",
      filesize: "53 KB",
      filetype: "PDF",
    },
    {
      key: "4",
      name: "Location Image",
      filesize: "53 KB",
      filetype: "PDF",
    },
    {
      key: "5",
      name: "Location Image",
      filesize: "53 KB",
      filetype: "PDF",
    },
  ];

  const columns1 = [
    {
      title: "Name",
      dataIndex: "name",
      key: "name",
    },
    {
      title: "File Size",
      dataIndex: "filesize",
      key: "filesize",
    },
    {
      title: "File Type",
      dataIndex: "filetype",
      key: "filetype",
    },
    {
      title: "Added By",
      dataIndex: "addedby",
      key: "addedby",
      render: (text, record) => {
        return (
          <>
            <div className="consingment_container_record">
              <p>Tony Fernandes</p>
              <p>24th Aug 2024; 07:10 AM</p>
            </div>
          </>
        );
      },
    },
    {
      title: "",
      dataIndex: "",
      key: "",
      render: (_, record) => (
        <>
          <div className="consingment_container_two">
            <EyeOutlined style={{ marginRight: "13px", fontSize: "17px" }} />
            <DownloadIcon style={{ marginRight: "13px" }} />
            <DeleteIcon />
          </div>
        </>
      ),
    },
  ];
  const data2 = [
    {
      key: "1",
      name: "Location Image",
      filesize: "53 KB",
      filetype: "PDF",
    },
    {
      key: "2",
      name: "Location Image",
      filesize: "53 KB",
      filetype: "PDF",
    },
    {
      key: "3",
      name: "Location Image",
      filesize: "53 KB",
      filetype: "PDF",
    },
    {
      key: "4",
      name: "Location Image",
      filesize: "53 KB",
      filetype: "PDF",
    },
    {
      key: "5",
      name: "Location Image",
      filesize: "53 KB",
      filetype: "PDF",
    },
  ];

  const columns2 = [
    {
      title: "KPI name",
      dataIndex: "MKPID",
      key: "MKPID",
      render: (text) => {
        return kpiData?.find((item) => item.ID === text)?.Name || "-";
      },
    },
    {
      title: "Vehicle Type",
      dataIndex: "VEHTYPE",
      key: "VEHTYPE",
      render: (text) => {
        return vehicleType?.find((item) => item.ID === text)?.NAME || "-";
      },
    },
    {
      title: "Minutes Exceed",
      dataIndex: "MAXMINUTES",
      key: "MAXMINUTES",
      render: (text) => {
        return text || "-";
      },
    },
    {
      title: "Added By",
      dataIndex: "CRBY",
      key: "CRBY",
      render: (text, record) => (
        <>
          <div className="consingment_container_record">
            <p>{record?.CRBY}</p>
            <p>{moment(record?.CRON).format("Do MMM YYYY; hh:mm A")}</p>
          </div>
        </>
      ),
    },
    {
      title: "",
      dataIndex: "",
      key: "",
      render: (_, record) => (
        <>
          <div className="consingment_container_two">
            <EditIcon
              style={{ marginRight: "13px" }}
              onClick={() => {
                setIsKpiEdit(true);
                setIsModalOpeN(true);
                setKpiDetailsData({
                  ID: record?.ID,
                  kpiName: record?.MKPID,
                  vehicleType: record?.VEHTYPE,
                  minutesExceed: record?.MAXMINUTES,
                  CRBY: record?.CRBY,
                });
                form.setFieldsValue({
                  kpiName: record?.MKPID,
                  vehicleType: record?.VEHTYPE,
                  minutesExceed: record?.MAXMINUTES,
                });
              }}
            />
            <DeleteIcon
              onClick={() => {
                setDeleteId(record?.ID);
                setIsDeleteModalVisible(true);
              }}
            />
          </div>
        </>
      ),
    },
  ];

  const handlechange = (key) => {
    setactivekey(key);
  };

  const handleClickme = () => {
    setIsView(false);
  };
  const handleeditclick = () => {
    setIsEdit(true);
    setDrawyeropen(true);
    setFormData({
      Consignorcode: consignee?.ENTCODE,
      Consignorname: consignee?.ENTNAME,
      Country: consignee?.COUNTRY,
      town: consignee?.TID,
      fence: consignee?.ENTNAME,
      Contactperson: consignee?.CONTACTPERSON,
      phone: consignee?.PHONE,
      // Countrycode: record.Mobile,
      Mobile: consignee.Mobile,
      Email: consignee?.EMAIL,
      Physicalocation: consignee?.ADDRESS,
      switch: false,
      TripAvgtime: "",
      ENTID: consignee?.ENTID,
      MCID: consignee?.MCID,
    });
  };

  const handleDeleteKpi = async (id) => {
    setLoading(true);
    const { data } = await CALL_API("Delete", `entity/delete_entity_kpi`, {
      ID: id,
    });
    fetchKPIData();

    message.success("Data Deleted Successfully");
    setLoading(false);
  };

  const handleSubmit = async (values) => {
    setLoading(true);
    const payload = {
      ENTID: consignee?.ENTID,
      MKPID: values?.kpiName,
      VEHTYPE: values?.vehicleType,
      MAXMINUTES: values?.minutesExceed,
      CRBY: isKpiEdit ? Number(kpiDetailsData?.CRBY) : userInfo?.UID,
    };

    const updatePayload = {
      ID: kpiDetailsData?.ID,
      ENTID: consignee?.ENTID,
      MKPID: values?.kpiName,
      VEHTYPE: values?.vehicleType,
      MAXMINUTES: values?.minutesExceed,
    };

    const { data } = await CALL_API(
      isKpiEdit ? "PATCH" : "POST",
      isKpiEdit ? "entity/update_entity_kpi" : "entity/insert_entity_kpi",
      isKpiEdit ? updatePayload : payload,
    );
    message.success(
      isKpiEdit ? "Data Updated Successfully" : "Data Added Successfully",
    );
    fetchKPIData();
    setIsModalOpeN(false);
    form.resetFields();
    setKpiDetailsData({});
    setLoading(false);
  };

  const kpiData = [
    {
      ID: 13,
      Name: "Time After Offloading KPI Alert ",
    },
    {
      ID: 25,
      Name: "test  KPI ",
    },
    {
      ID: 27,
      Name: "KPI 190924",
    },
    {
      ID: 29,
      Name: "detect",
    },
    {
      ID: 34,
      Name: "sample",
    },
    {
      ID: 37,
      Name: "test",
    },
    {
      ID: 38,
      Name: "gdsd",
    },
    {
      ID: 39,
      Name: "test2",
    },
    {
      ID: 40,
      Name: "test4",
    },
    {
      ID: 42,
      Name: "CONTAINER Test KPI for container tracking",
    },
    {
      ID: 44,
      Name: "Container time after offloading",
    },
    {
      ID: 45,
      Name: "container time after loading",
    },
    {
      ID: 46,
      Name: "Delay in Container Offloading Time",
    },
    {
      ID: 47,
      Name: "container offloading wait time",
    },
    {
      ID: 48,
      Name: "Delay in return journey started",
    },
    {
      ID: 49,
      Name: "Delay in Time After Loading Container",
    },
    {
      ID: 50,
      Name: "TestING KPI",
    },
    {
      ID: 54,
      Name: "update KPI",
    },
  ];
  return (
    <>
      <WrapperBox>
        <Row gutter={16}>
          <Col xs={24} xl={24}>
            <div className="consingment_container">
              <div className="consingment_container_two">
                <ButtonOutlined onClick={handleClickme} className="Create_btn">
                  <LeftOutlined className="left_outlined_icon" />
                </ButtonOutlined>
                <p>{consignee?.ENTCODE}</p>
              </div>

              <div className="consingment_container_two  consingment_container_formbresponsive">
                <EditIcon
                  style={{
                    cursor: isUpdateAllowed ? "pointer" : "not-allowed",
                    marginRight: "20px",
                  }}
                  onClick={() => {
                    if (!isUpdateAllowed) return;
                    handleeditclick();
                  }}
                />
                <DeleteIcon
                  style={{
                    cursor: isDeleteAllowed ? "pointer" : "not-allowed",
                  }}
                  onClick={() => {
                    if (!isDeleteAllowed) return;
                    setDeleteId(consignee?.ENTID);
                    setIsDeleteModalVisible(true);
                  }}
                />
              </div>
            </div>
          </Col>
        </Row>
      </WrapperBox>
      <WrapperBox>
        <Row gutter={16}>
          <Col xs={24} xl={24}>
            <div className="container_for_consignorpage">
              <div className="consignor_code">
                <label>Entity Code</label>
                <p>{consignee?.ENTCODE}</p>
              </div>
              <div className="consignor_code">
                <label>Entity Name</label>
                <p>{consignee?.ENTNAME}</p>
              </div>
              <div className="consignor_code">
                <label>Address</label>
                <p>{consignee?.ADDRESS}</p>
              </div>
              <div className="consignor_code">
                <label>Country</label>
                <p>{consignee?.COUNTRY}</p>
              </div>
              <div className="consignor_code">
                <label>Town</label>
                <p>{consignee?.TOWNNAME || "-"}</p>
              </div>
              <div className="consignor_code">
                <label>Contact Person</label>
                <p>{consignee?.CONTACTPERSON || "-"}</p>
              </div>
              <div className="consignor_code">
                <label>Phone</label>
                <p>{consignee?.PHONE || "-"}</p>
              </div>
              <div className="consignor_code">
                <label>Mobile</label>
                <p>{consignee?.Mobile || "-"}</p>
              </div>

              <div className="consignor_code_container  consignor_code">
                <label>Trip Avg Time (Minutes)</label>
                <p>---</p>
              </div>
              {Array.isArray(CustomData) &&
                CustomData.length > 0 &&
                CustomData.map((field) => (
                  <div className="consignor_code" key={field.CFID}>
                    <label>{field.FIELDNAME}</label>
                    <p>{field.VALUE || "-"}</p>
                  </div>
                ))}
            </div>
          </Col>
        </Row>
      </WrapperBox>

      <WrapperBox>
        <Row gutter={16}>
          <Col xl={24} xs={24}>
            <div style={{ marginTop: "12px" }} className="tabsectionfor_table">
              <Tabs
                className="consignor_tab_container"
                onChange={handlechange}
                type="card"
                items={[
                  {
                    label: "Files",
                    key: "1",
                  },
                  {
                    label: "KPI Settings",
                    key: "2",
                  },
                ]}
              />
              {activekey === "2" && (
                <ButtonFilled onClick={() => setIsModalOpeN(true)}>
                  {" "}
                  + Add{" "}
                </ButtonFilled>
              )}

              {activekey === "1" && (
                <Upload
                  customRequest={({ file, onSuccess }) => {
                    // Get current position
                    navigator.geolocation.getCurrentPosition(
                      (position) => {
                        const { latitude, longitude } = position.coords;
                        const reader = new FileReader();
                        reader.readAsDataURL(file);

                        reader.onload = () => {
                          const base64Data = reader.result.split(",")[1];
                          onSuccess();

                          const payload = {
                            title: file.name,
                            fileSize: file.size,
                            mimeType: 1,
                            crBy: userInfo?.UID,
                            attKey: "testKey",
                            refTab: "ENTITY",
                            refId: consignee?.ENTID,
                            lat: String(latitude),
                            lng: String(longitude),
                            crOn: new Date(),
                            fileName: file.name,
                            fileType: file.name.split(".").pop(),
                            file: reader.result,
                          };
                          handleFileUpload(payload);
                        };

                        reader.onerror = (error) => {
                          console.error("File read error:", error);
                        };
                      },
                      (error) => {
                        // If location access denied or failed, fallback to empty values
                        console.error("Geolocation error:", error);
                        const reader = new FileReader();
                        reader.readAsDataURL(file);

                        reader.onload = () => {
                          onSuccess();
                          const payload = {
                            title: file.name,
                            fileSize: file.size,
                            mimeType: 1,
                            crBy: userInfo?.UID,
                            attKey: "testKey",
                            refTab: "ENTITY",
                            refId: consignee?.ENTID,
                            lat: "",
                            lng: "",
                            crOn: new Date(),
                            fileName: file.name,
                            fileType: file.name.split(".").pop(),
                            file: reader.result,
                          };
                          handleFileUpload(payload);
                        };
                      },
                    );
                  }}
                  showUploadList={false}
                >
                  <ButtonFilled className="upload-style1">+ Add</ButtonFilled>
                </Upload>
              )}
            </div>
          </Col>
        </Row>

        {activekey === "1" && (
          <Spin spinning={loading}>
            <FilesTable filesList={filesList} getFileData={getFileData} />
          </Spin>
        )}
        {activekey === "2" && (
          <StyledTable
            dataSource={kpiList}
            pagination={false}
            columns={columns2}
          />
        )}
      </WrapperBox>

      {/* <ReusableDrawer
        title=""
        open={drawyeropen}
        setOpen={setDrawyeropen}
        onClose={handleClose}
        closable={false}
        footer={[
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              alignItems: "center",
              justifyContent: "flex-end",
              gap: "15px",
            }}
          >
            <Button
              key="cancel"
              className="cancel-btn"
              onClick={handleClose}
              style={{
                borderRadius: "26px",
                backgroundColor: "#E8FFEC",
                color: "#2C963D",
                borderColor: "#E8FFEC",
                width: "118px",
                height: "38px",
              }}
            >
              Cancel
            </Button>
            <ButtonFilled
              key="create"
              type="primary"
              onClick={handleSubmitForm}
            >
              Create
            </ButtonFilled>
          </div>,
        ]}
      >
        <WrapperBox>
          <Row gutter={16}>
            <Col xl={24} xs={24}>
              <div className="Creating_Consignor">
                <p>Creating Consignor</p>

                <span>
                  <CloseOutlined onClick={handleClose} />
                </span>
              </div>
            </Col>
          </Row>
          <Row gutter={16}>
            <Col xl={24} xs={24}>
              <GridBuilder
                formStructureJson={AddEditFormm}
                handleChange={handleChange}
                formSubmit={handleSubmitForm}
                initialValues={formData}
                form={form}
              />
            </Col>
          </Row>
        </WrapperBox>
      </ReusableDrawer> */}
      <Modal
        title={isKpiEdit ? "Editing KPI" : "Adding KPI"}
        visible={isModalOpeN}
        onCancel={() => {
          setIsModalOpeN(false);
          form.resetFields();
          setKpiDetailsData({});
        }}
        footer={[
          <Buttontransparent
            onClick={() => {
              setIsModalOpeN(false);
              form.resetFields();
              setKpiDetailsData({});
            }}
          >
            Cancel
          </Buttontransparent>,
          <ButtonFilled onClick={() => form.submit()} loading={loading}>
            {isKpiEdit ? "Edit" : "Add"}
          </ButtonFilled>,
        ]}
      >
        <Form
          form={form}
          layout="vertical"
          onFinish={handleSubmit}
          initialValues={kpiDetailsData}
        >
          <Row gutter={16}>
            <Col sm={24} md={12}>
              <Form.Item
                name="kpiName"
                label="KPI Name"
                rules={[
                  { required: true, message: "Please select a KPI Name" },
                ]}
              >
                <Select
                  placeholder="Select KPI Name"
                  options={kpiData?.map((item) => ({
                    value: item?.ID,
                    label: item?.Name,
                  }))}
                />
              </Form.Item>
            </Col>
            <Col sm={24} md={12}>
              <Form.Item
                name="vehicleType"
                label="Vehicle Type"
                rules={[
                  { required: true, message: "Please select a Vehicle Type" },
                ]}
              >
                <Select
                  placeholder="Select Vehicle Type"
                  options={vehicleType?.map((item) => ({
                    value: item.ID,
                    label: item.NAME,
                  }))}
                />
              </Form.Item>
            </Col>
            <Col sm={24} md={12}>
              <Form.Item
                name="minutesExceed"
                label="Minutes Exceed"
                rules={[
                  { required: true, message: "Please enter minutes exceed" },
                ]}
              >
                <InputNumber
                  min={1}
                  type="number"
                  style={{ width: "100%" }}
                  onKeyDown={(e) => {
                    const value =
                      /^[0-9]$/?.test(e.key) || /^[a-zA-Z\s]+$/?.test(e.key);
                    if (!value && e.key !== "Backspace" && /^[0-9]$/) {
                      e.preventDefault();
                    }
                  }}
                />
              </Form.Item>
            </Col>
          </Row>
        </Form>
      </Modal>
      <UIModal
        width={500}
        open={isDeleteModalVisible}
        onClose={() => {
          setIsDeleteModalVisible(false);
          setDeleteId(null); // Reset the delete ID
        }}
        closeButton={false}
        size="md"
        header={false}
        footer={false}
      >
        <div className="text-center">
          <h1>Are you sure,</h1>
          <h6>You want to delete this Entity?</h6>
          <div className="mt-2 w-100 d-flex justify-content-center">
            <ButtonFilled
              loading={dloading}
              onClick={() => {
                handleDelete(deleteId); // Call the delete function with the selected ID
                setIsDeleteModalVisible(false); // Close the modal
                setDeleteId(null); // Reset the delete ID
              }}
            >
              Yes
            </ButtonFilled>
            <Buttontransparent
              onClick={() => {
                setIsDeleteModalVisible(false); // Close the modal
                setDeleteId(null); // Reset the delete ID
              }}
            >
              No
            </Buttontransparent>
          </div>
        </div>
      </UIModal>
    </>
  );
};

export default Consignordetails;
